import React from 'react'
import Timetable from '../components/Timetable'

function Timetablee() {
  return (
    <div>
      <Timetable/>
    </div>
  )
}

export default Timetablee
